import React from "react";
import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import mathHelper from "../Helpers/mathHelper";

class IobLineItemTransactionAdminFees {
  constructor(item) {
    if (item === undefined) {
      this.IoblineItemId = '';
      this.IobinvoiceId = '';
      this.CurrencyId = '';
      this.CurrencyName = '';
      this.CurrencySymbol = '';
      this.Amount = '';
      this.Amount1 = '';
      this.Amount2 = '';
      this.AmountPaid = '';
      this.AmountDue = '';
      this.Description = '';
      this.TypeCode = '';
      this.Type = '';
      this.InvoiceId = '';
      this.AssignmentId = '';
      this.AssignmentApolloId = '';
      this.AssignmentStatus = '';
      this.AssignmentCountryCode = '';
      this.AssignmentCountryName = '';
      this.EvaluatorCountryCode = '';
      this.EvaluatorCountryName = '';
      this.InvoiceEvaluatorId = '';
      this.ExportPaymentId = '';
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.ExportId = '';
      this.TransactionFee = '';
      this.ExportPaymentCurrencyId = '';
      this.AdministrativeFee = '';
      this.EvaluatorFirstName = '';
      this.EvaluatorLastName = '';
      this.EvaluatorId = '';
      return;
    }
    this.IoblineItemId = item.ioblineItemId;
    this.IobinvoiceId = item.iobinvoiceId;
    this.CurrencyId = item.currencyId;
    this.CurrencyName = item.currencyName;
    this.CurrencySymbol = item.currencySymbol;
    this.Amount = mathHelper.ConvertToTwoDecimalNumber(item.amount);
    this.Amount1 = mathHelper.ConvertToTwoDecimalNumber(item.amount1);
    this.Amount2 = mathHelper.ConvertToTwoDecimalNumber(item.amount2);
    this.AmountPaid = item.amountPaid === null ? '0.00' : mathHelper.ConvertToTwoDecimalNumber(item.amountPaid);
    this.AmountDue = mathHelper.ConvertToTwoDecimalNumber(item.amountDue);
    this.Description = item.description;
    this.TypeCode = item.typeCode;
    this.Type = item.type;
    this.InvoiceId = item.invoiceId;
    this.AssignmentId = item.assignmentId;
    this.AssignmentApolloId = item.assignmentApolloId;
    this.AssignmentStatus = item.assignmentStatus;
    this.AssignmentCountryCode = item.assignmentCountryCode;
    this.AssignmentCountryName = item.assignmentCountryName;
    this.EvaluatorCountryCode = item.evaluatorCountryCode;
    this.EvaluatorCountryName = item.evaluatorCountryName;
    this.InvoiceEvaluatorId = item.invoiceEvaluatorId;
    this.ExportPaymentId = item.exportPaymentId;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByName = item.modifiedByName;
    this.ExportId = item.exportId;
    this.TransactionFee = mathHelper.ConvertToTwoDecimalNumber(item.transactionFee);
    this.ExportPaymentCurrencyId = item.exportPaymentCurrencyId;
    this.AdministrativeFee = mathHelper.ConvertToTwoDecimalNumber(item.administrativeFee);
    this.EvaluatorFirstName = item.evaluatorFirstName;
    this.EvaluatorLastName = item.evaluatorLastName;
    this.EvaluatorId = item.evaluatorId;
    this.EvaluatorName = `${item.evaluatorFirstName}, ${item.evaluatorLastName}`;
  }

  static NameOfTheIdField() {
    return "IobinvoiceId";
  }

  static editGeneralFunction = (id, user, userList) => {
    alert("Empty function");
  };

  static nameOfTheItemDetailList() {
    return "IOB";
  }

  static Currency() {
    return "CurrencyName";
  }

  static CurrencySecondary() {
    return "";
  }

  static MoneyFields = [
    "Amount",
    "AmountPaid",
    "Amount1",
    "Amount2",
    "ExportPaymentTransactionFee",
    "ExportPaymentAdministrativeFee",
    "ExportPaymentFee",
    "ExportPaymentFeeOriginal",
    "ExportPaymentFeeBase",
    "ExportPaymentFeeBaseOriginal",
    "ExportPaymentFeeAdjustment",
    "ExportPaymentMisc",
    "ExportPaymentTravel",
    "ExportPaymentGaming",
    "ExportPaymentReimbursement",
    "ExportPaymentExpense",
    "ExportPaymentTotal",
    "ExportPaymentPaid",
    "ExportPaymentDue",
    "ExportPaymentVat",
  ];
  static MoneyFieldsSecondary = [];
  static DateFields = [];
  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path="assignments"
        tooltipText={item.AssignmentApolloId}
        text={item.AssignmentApolloId}
        isFigmaStyle={true}
        keyValuePairs={[
          { key: "AsBillClient", value: "" },
          { key: "AsPayEvaluator", value: "" },
          { key: "AsSassieAsgnId", value: item.AssignmentApolloId },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: "Export Payment ID", orderById: "ExportPaymentId", data: "ExportPaymentId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 135 },
      { label: "Type", orderById: "Type", data: "Type" },
      { label: "Export ID", orderById: "ExportId", data: "ExportId" },
      { label: "Evaluator", orderById: "EvaluatorName", data: "ExportPaymentEvaluatorContactName" },
      { label: "Evaluator Country", orderById: "EvaluatorCountryName", data: "EvaluatorCountryName" },
      { label: "Transaction Fee", orderById: "Amount1", data: "Amount1" },
      { label: "Administrative Fee", orderById: "Amount2", data: "Amount2" },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: "Payment",
      tabLabel: "Payment",
      icon: "fa-solid fa-money-bill-wave",
      data: [
        { label: "CurrencyId", name: "ExportPaymentCurrencyId" },
        { label: "CurrencyCode", name: "ExportPaymentCurrencyCode" },
        { label: "CurrencySymbol", name: "ExportPaymentCurrencySymbol" },
        { label: "PaymentMethod", name: "ExportPaymentPaymentMethod" },
        { label: "PaymentMethodName", name: "ExportPaymentPaymentMethodName" },
        { label: "StatusCode", name: "ExportPaymentStatusCode" },
        { label: "StatusCodeName", name: "ExportPaymentStatusCodeName" },
        { label: "PaymentDate", name: "ExportPaymentPaymentDate" },
        { label: "ReconciliationDate", name: "ExportPaymentReconciliationDate" },
        { label: "TransactionDate", name: "ExportPaymentTransactionDate" },
        { label: "TransactionFee", name: "ExportPaymentTransactionFee" },
        { label: "AdministrativeFee", name: "ExportPaymentAdministrativeFee" },
        { label: "TransactionMethod", name: "ExportPaymentTransactionMethod" },
        { label: "TransactionReferenceNumber", name: "ExportPaymentTransactionReferenceNumber" },
        { label: "Fee", name: "ExportPaymentFee" },
        { label: "FeeOriginal", name: "ExportPaymentFeeOriginal" },
        { label: "FeeBase", name: "ExportPaymentFeeBase" },
        { label: "FeeBaseOriginal", name: "ExportPaymentFeeBaseOriginal" },
        { label: "FeeAdjustment", name: "ExportPaymentFeeAdjustment" },
        { label: "Misc", name: "ExportPaymentMisc" },
        { label: "Travel", name: "ExportPaymentTravel" },
        { label: "Gaming", name: "ExportPaymentGaming" },
        { label: "Reimbursement", name: "ExportPaymentReimbursement" },
        { label: "Expense", name: "ExportPaymentExpense" },
        { label: "Total", name: "ExportPaymentTotal" },
        { label: "Paid", name: "ExportPaymentPaid" },
        { label: "Due", name: "ExportPaymentDue" },
        { label: "Vat", name: "ExportPaymentVat" },
      ],
    },
  ];
}

export default IobLineItemTransactionAdminFees;
